const PREVIEW_CLASS = 'colour-swatches__preview';

function getGallery(swatchList) {
  const card = swatchList.closest('product-card');
  return card ? card.querySelector('.card-gallery') : null;
}

function getPreview(gallery) {
  let preview = gallery.querySelector(`.${PREVIEW_CLASS}`);
  if (!preview) {
    preview = document.createElement('img');
    preview.className = PREVIEW_CLASS;
    preview.setAttribute('alt', '');
    preview.setAttribute('aria-hidden', 'true');
    preview.setAttribute('loading', 'lazy');
    gallery.appendChild(preview);
  }
  return preview;
}

function showPreview(swatch, container) {
  const source = swatch.dataset.swatchImage;
  if (!source) return;

  const gallery = getGallery(container);
  if (!gallery) return;

  const preview = getPreview(gallery);
  if (preview.getAttribute('src') !== source) {
    preview.setAttribute('src', source);
  }
  preview.setAttribute('data-visible', '');

  // The label appears on hover as well as on tap, so the colour is named
  // before the customer commits to it.
  // No label on hover. The colour is shown by the swatch itself and by the
  // image changing, so naming it as well was noise.
}

function hidePreview(container) {
  const gallery = getGallery(container);
  if (!gallery) return;

  const preview = gallery.querySelector(`.${PREVIEW_CLASS}`);
  if (!preview) return;

  // A colour chosen by clicking stays put when the pointer leaves.
  if (preview.dataset.committed === 'true') return;

  preview.removeAttribute('data-visible');

}

// Hover previews are a pointer affordance. On touch the swatch simply follows
// its link, which is the behaviour on the product page too.
if (window.matchMedia('(hover: hover)').matches) {
  document.querySelectorAll('[data-colour-swatches]').forEach((container) => {
    if (container.dataset.swatchPreviewBound) return;
    container.dataset.swatchPreviewBound = 'true';

    // Hover preview is pointer only. On touch there is no hover, and firing it
    // from a tap left the card in a preview state that the click then fought.
    container.addEventListener('pointerover', (event) => {
      if (event.pointerType === 'touch') return;
      const swatch = event.target.closest('[data-swatch-image]');
      if (swatch) showPreview(swatch, container);
    });

    container.addEventListener('focusin', (event) => {
      const swatch = event.target.closest('[data-swatch-image]');
      if (swatch) showPreview(swatch, container);
    });

    container.addEventListener('pointerleave', () => hidePreview(container));
    container.addEventListener('focusout', (event) => {
      if (!container.contains(event.relatedTarget)) hidePreview(container);
    });
  });
}

/*
 * The swatch button sits inside the card's product link, which is invalid
 * markup, so the parser relocates it. A listener bound to the swatch container
 * therefore never saw the tap. This is delegated from the document instead, so
 * it works wherever the button ends up.
 */
document.addEventListener(
  'click',
  (event) => {
    const swatch = event.target.closest('[data-swatch-url]');
    if (!swatch) return;

    const url = swatch.dataset.swatchUrl;
    const image = swatch.dataset.swatchImage;

    // On a pointer device the hover has already previewed the colour, so the
    // first click goes straight through. The two-step behaviour is only needed
    // on touch, where there is no hover to preview with.
    const canHover = window.matchMedia('(hover: hover)').matches;
    const alreadyChosen = swatch.getAttribute('aria-current') === 'true';

    if (url && (canHover || alreadyChosen)) {
      window.location.href = url;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const group =
      swatch.closest('[data-colour-swatches]') ||
      document.querySelector(`[data-colour-swatches]:has([data-swatch-url="${url}"])`);

    const card =
      swatch.closest('product-card') ||
      swatch.closest('.product-grid__item') ||
      (group && (group.closest('product-card') || group.closest('.product-grid__item')));

    if (card && url) {
      card.querySelectorAll('a[href]').forEach((link) => {
        if (!link.closest('[data-colour-swatches]')) link.setAttribute('href', url);
      });
    }

    if (image && card) {
      const gallery = card.querySelector('.card-gallery');
      if (gallery) {
        let preview = gallery.querySelector(`.${PREVIEW_CLASS}`);
        if (!preview) {
          preview = document.createElement('img');
          preview.className = PREVIEW_CLASS;
          preview.setAttribute('alt', '');
          preview.setAttribute('aria-hidden', 'true');
          gallery.appendChild(preview);
        }
        preview.setAttribute('src', image);
        preview.setAttribute('data-visible', '');
        preview.dataset.committed = 'true';
      }
    }

    const scope = group || card;
    if (scope) {
      // No colour label, on tap or on hover. The swatch and the image
      // already show which colour is chosen.

      scope.querySelectorAll('[data-swatch-url]').forEach((node) => {
        node.classList.toggle('colour-swatches__swatch--selected', node === swatch);
        if (node === swatch) node.setAttribute('aria-current', 'true');
        else node.removeAttribute('aria-current');
      });
    }
  },
  true
);
